<button
  mat-icon-button
  class="user-button"
  [matMenuTriggerFor]="menu"
  [class.impersonated]="impersonated$ | async"
>
  <mat-icon class="user-icon" fontSet="material-icons-outlined"
    >person</mat-icon
  >
  <mat-icon *ngIf="impersonated$ | async" class="secondary-icon"
    >priority_high</mat-icon
  >
</button>
<mat-menu #menu="matMenu" class="user-menu">
  <div *ngIf="user" class="user-menu__profil" fxLayout="row">
    <div class="monogram" fxLayoutAlign="center center">{{ monogram }}</div>
    <div fxLayout="column" fxLayoutAlign="center">
      <strong>{{ user.familyName }} {{ user.givenName }}</strong>
      <span>{{ user.email }}</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <ng-container
    *ngIf="
      (impersonated$ | async)
        ? true
        : !roles.includes('EASYLOT_ADMIN') &&
          !roles.includes('TELESALES') &&
          !roles.includes('IMPERSONATION')
    "
  >
    <a
      mat-menu-item
      [routerLink]="'/account/merchant'"
      class="sidenav-list-item"
    >
      <span>{{ "MENU.MERCHANT_BASIC_DATA" | translate }}</span>
    </a>
    <a mat-menu-item [routerLink]="'/account/users'" class="sidenav-list-item">
      <span>{{ "MENU.USERS" | translate }}</span>
    </a>
    <mat-divider></mat-divider>
  </ng-container>
  <ng-container *ngIf="impersonated$ | async">
    <button
      mat-menu-item
      class="sidenav-list-item impersonation-menu"
      (click)="removeImpersonation()"
    >
      <mat-icon class="primary-icon">person</mat-icon>
      <mat-icon class="secondary-icon">clear</mat-icon>
      <span>{{ "IMPERSONATION.EXIT" | translate }}</span>
    </button>
    <mat-divider></mat-divider>
  </ng-container>
  <a mat-menu-item [routerLink]="'/auth/logout'" class="sidenav-list-item">
    <mat-icon class="me-3">logout</mat-icon>
    <span>{{ "HEADER.BTN.LOGOUT" | translate }}</span>
  </a>
</mat-menu>
